import Initials from './initials.js';

export default class Selector {

  constructor() {
    this.Initials = new Initials();
    const self = this,
    chosenImageSelects = document.querySelectorAll('.chosen-image-select'),
    chosenSelects = document.querySelectorAll('.chosen-select, .chosen-image-select, .chosen-grid-select, .chosen-grid-small'),
    deploymentSelector = document.querySelector('.js-deployment-selector'),
    selectorRedirect = document.querySelector('.selector-redirect');

    this.orgSelector = document.querySelector('#org-selector');
    if (this.orgSelector) {
      this.initOrgSelector();
    }

    this.topFilter = document.querySelector('#topFilter');
    if (this.topFilter) {
      this.initTopFilter();
    }

    if (chosenImageSelects.length) {
      chosenImageSelects.forEach(select => {
        self.initImageSelector(select);
      });
    }

    if (chosenSelects.length) {
      chosenSelects.forEach(select => {
        const addOption = select.querySelector('.js-add-option');
        addOption && self.initAddOption(addOption);
      });
    }

    if ( deploymentSelector ) {
      deploymentSelector.onchange = ({ target }) => {
        const { value } = target;
        if ( value === 'add' ) {
          this.handleAddOptionRedirect(target);
        } else {
          const { orgName } = window.solodev.config;
          const type = target.dataset.type;
          window.location = '/o/' + orgName + '/' + type + 's/' + value;
        }
      }
    }

    if (selectorRedirect) {
      this.selectorRedirect = selectorRedirect;
      this.initSelectorRedirect();
    }
  }

  initImageSelector(select) {
    const { options } = select;

    for (const opt of options) {
      const { imgUrl, name, title, badgeColor, badgeLabel, badgeOutline = false, defaultAvatar = null, icon, optionWidth } = opt.dataset;
      const setDefaultAvatar = [null, 'true'].includes(defaultAvatar);

      if ( !name ) continue;

      if ( badgeLabel && badgeColor ) {
        const color = badgeOutline ? 'outline-' + badgeColor : badgeColor;
        $(opt)
          .text('')
          .prepend(`
            <div class="d-flex align-items-center no-wrap w-100">
              ${ imgUrl ? '<img class="selector-avatar" alt="' + (title || name || "") + ' logo" src="' + imgUrl + '" >' : '' }
              <p class="m-0 pe-1 text-ellipsis ${ optionWidth ? 'w-xs-' + optionWidth : '' }">${ title || name }</p>
              <div class="ms-4"><span class="badge badge-${ color }">${ badgeLabel }</span></div>
            </div>
          `)
        .addClass('no-wrap');
      } else if (imgUrl) {
        $(opt)
          .text('')
          .prepend(`<p class="w-lg-90 m-0 pe-1 text-ellipsis">${ title || name }</p>`)
          .prepend(`<img class="selector-avatar" alt="${ title || name } logo" src="${ imgUrl }">`)
          .addClass('no-wrap d-flex align-items-center');
      } else if (icon) {
        $(opt)
          .prepend('<span class="fas ' + icon + ' pe-2 w-xs-25p d-inline"></span>');
      } else if (setDefaultAvatar) {
        let color = this.Initials.initialsToColor(name);
        $(opt)
          .prepend(`<span class="color-avatar default-avatar rounded-circle d-flex align-items-center justify-content-center">${ name.charAt(0).toUpperCase() }</span>`)
          .addClass('no-wrap')
          .find('.default-avatar')
          .css('background-color', color);
      }

      if (name == 'purchase') {
        $(opt)
          .prepend('<p class="position-absolute inner bg-white mb-0">Purchased and ready to install</p>');
      }
    }

    if (select !== this.orgSelector) {
      select.onchange = ({ target }) => {
        const { value } = target;
        const addOption = target.querySelector('.js-add-option');
        if ( value === 'add' || addOption?.selected) {
          this.handleAddOptionRedirect(target);
        }
      }
    }
  }

  initOrgSelector() {
    const isMobileScreen = window.matchMedia('(max-width: 990px)').matches;

    if (isMobileScreen) {
      this.orgSelector.style.zIndex = "1" ;
    }

    this.orgSelector.onchange = (e) => {
      const name = e.target.value;

      if (isMobileScreen) {
        const dataImg = e.target.options[e.target.options.selectedIndex].dataset.imgUrl || null;
        const newOrgTitle = e.target.options[e.target.options.selectedIndex].innerText.trim();
        const orgImg = document.querySelector('#org-img');
        const orgAvatar = document.querySelector('#org-avatar');

        if (dataImg) {
          orgImg.style.backgroundImage = "url(" + dataImg  + ")";
          orgAvatar.classList.add('d-none');
          orgAvatar.classList.remove('d-flex');
          orgImg.classList.remove('d-none');
        } else {
          orgImg.classList.add('d-none');
          orgAvatar.classList.remove('d-none');
          orgAvatar.classList.add('d-flex')
          orgAvatar.innerText = name.charAt(0).toUpperCase();
          orgAvatar.style.backgroundColor = this.Initials.initialsToColor(name);
        }
        orgAvatar.nextElementSibling.innerText = newOrgTitle;
      }

      window.location = window.location.pathname.replace(/\/o\/(.+?)\//, '/o/' + name + '/');
      sessionStorage.setItem('current_org', name);
    }
  }

  initTopFilter() {
    const url = this.topFilter.dataset.url;
    const name = this.topFilter.getAttribute('name');

    const { preventRefresh } = this.topFilter.dataset;
    if ( preventRefresh ) return;

    this.topFilter.onchange = () => {
      const value = this.topFilter.value;
      if ( value === 'add' ) {
        this.handleAddOptionRedirect(this.topFilter);
      } else {
        window.location.href = value ? (url + '?' + name + '=' + value) : url;
      }
    }
  }

  initAddOption = (addOption) => addOption.innerHTML = `<i class="fas fa-plus text-vulcan pe-2"></i> ${ addOption.dataset.label }`;

  handleAddOptionRedirect(select) {
    const option = select.querySelector('.js-add-option');

    if (select.multiple) {
      const values = $(select).chosen().val();
      const valuesWithoutAddOption = values.filter(value => value !== 'add')
      $(select).val(valuesWithoutAddOption).trigger('chosen:updated');
    } else {
      $(select).val('').trigger('liszt:updated').trigger('chosen:updated');
    }

    const url = option.dataset.url;
    if ( url ) {
      window.open(url, '_blank');
    }
  }

  initSelectorRedirect() {
    this.selectorRedirect.onchange = (e) => {
      const name = e.target.value;
      window.location = window.location.pathname.replace(/\/o\/(.+?)\//, '/o/' + name + '/');
    }
  }
}
